export const ForwardLargeIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path opacity="0.7" d="M2 14.7525L8.9559 8.37624L2 2" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        <path opacity="0.7" d="M10.5352 14.7525L17.4911 8.37624L10.5352 2" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    `,
      }}
    />
  );
};
